import { useEffect } from "react";
import { CTAButton } from "../components/ui-regera/CTAButton";

export default function NotFound() {
  useEffect(() => {
    document.title = "404 — REGERA";
  }, []);
  return (
    <div data-testid="not-found-page" className="min-h-screen flex items-center justify-center px-5">
      <div className="text-center">
        <p className="overline justify-center">Page not found</p>
        <h1 className="mt-6 font-display font-black tracking-tightest text-[28vw] sm:text-[20vw] lg:text-[220px] leading-none text-white">
          4<span className="text-[#e60000]">0</span>4
        </h1>
        <p className="mt-4 text-regera-dim max-w-md mx-auto">
          The page you're looking for has transformed into something else — or never existed.
        </p>
        <div className="mt-10 flex justify-center gap-4 flex-wrap">
          <CTAButton to="/" testId="notfound-home">RETURN HOME</CTAButton>
          <CTAButton to="/portfolio" variant="ghost" testId="notfound-portfolio">VIEW PORTFOLIO</CTAButton>
        </div>
      </div>
    </div>
  );
}
